// Utils
import { LinkCreationService } from '@sportal365/smp-widget-utils';

// Constants
import { TARGET_BLANK, TARGET_SELF } from '../../../../packages/constants/windowTarget';
import { PLAYER_ENTITY } from '../../../../packages/constants/entityTypes';

// Types
import { IConfigEntityLinks } from '../../../../packages/types';
import { ITennisRanking } from '../../../../packages/types/tennisV2';

interface ITennisRankingParams {
  data: ITennisRanking;
  dataHighlightEntities: string[];
  dataEntityLinks?: IConfigEntityLinks | null;
}

export const normalizeTennisRanking = ({ data, dataHighlightEntities, dataEntityLinks }: ITennisRankingParams) => {
  const linkService = dataEntityLinks && new LinkCreationService(dataEntityLinks);
  const target = dataEntityLinks?.configuration?.newWindow ? TARGET_BLANK : TARGET_SELF;

  if (!data) return;

  const normalizedRankingRows = data.rows?.map((row) => ({
    ...row,
    link: linkService?.createEntityUrl(row.athlete.id, PLAYER_ENTITY, '', row.athlete?.slug) ?? '#',
    urlTarget: target,
    isHighlighted: row.athlete?.id ? dataHighlightEntities.includes(row.athlete.id) : false,
  }));

  return {
    ...data,
    rows: normalizedRankingRows ?? [],
  };
};
